module.exports = __webpack_public_path__ + "static/media/lichi.82c65097.ogg";